<template>
  <div class="min-h-screen bg-background">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// App principal de Vue
</script>